export default __webpack_public_path__ + "static/云启资本-dea383b13f5d191b32e5ab70b13aa73e.png";